import clsx from 'clsx';
import React from 'react';
import { Fit } from '../utils/utils';
import uiConfig from '../data/uiConfig';

interface ImageBackgroundProps {
  children?: React.ReactNode;
  src: string;
  height?: number | string;
  fullHeight?: boolean;
  fit?: Fit;
  filter?: string | 'brightness' | 'blur' | 'none';
  opacity?: string;
  corner?: string;
}

export const ImageBackground: React.FC<ImageBackgroundProps> = ({
  children,
  src,
  height = 300,
  fullHeight = false,
  fit = 'cover',
  filter = 'none',
  opacity = 'opacity-50',
  corner = uiConfig.imageBackground.corner,
}) => {
  let classHeight="min-h-container";
  return (
    <div
      className={clsx("relative flex flex-col items-center justify-center",
        corner,
        fullHeight && classHeight
      )}
      style={{
        height: !fullHeight ? (typeof height === 'number' ? `${height}px` : height) : undefined,
      }}
    >
      <div
        className={clsx(
          "absolute inset-0 bg-center bg-no-repeat",
          filter === 'blur' && 'blur-xs',
          filter === 'brightness' && 'brightness-110',
          corner
        )}
        style={{
          backgroundImage: `url(${src})`,
          backgroundSize: fit,
        }}
        aria-hidden="true"
      />
      {typeof filter === 'string' && filter !== 'none' && filter !== 'blur' && filter !== 'brightness' && (
        <div
          className={clsx(
            "absolute inset-0 bg-center bg-no-repeat",
            `${filter} ${opacity}`,
          corner
          )}
          aria-hidden="true"
        />)}
      <div className="relative flex flex-col w-full items-center justify-center">
        {children}
      </div>
    </div>
  );
};
